'use strict';

module.exports = {
  newInTemplate: 'newInTemplate',
  newInScenario: 'newInScenario',
  existingFromAG: 'existingFromAG',
  existingManually: 'existingManually',
  existing: 'existing',
  newFromPeriodID: 'newInScenarioFromPeriodID',
};
